var _rect, _rect2, _rect3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonPadRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 56,
    rx: 4,
    fill: "#E7E7E7",
    stroke: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1865,
    y: 42.2036,
    width: 25.2654,
    height: 6.11533,
    transform: "rotate(-45.5467 18.1865 42.2036)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5601,
    y: 16.7075,
    width: 6.75984,
    height: 18.5232,
    transform: "rotate(-44.791 18.5601 16.7075)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.8201 30.42L23.2401 47L17.5801 41.34L29.9201 29L17.5801 16.66L23.2201 11L39.8201 27.58C40.0075 27.7659 40.1563 27.9871 40.2579 28.2308C40.3594 28.4746 40.4117 28.736 40.4117 29C40.4117 29.264 40.3594 29.5254 40.2579 29.7692C40.1563 30.0129 40.0075 30.2341 39.8201 30.42Z",
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPadRight);
export default __webpack_public_path__ + "static/media/button-pad-right.3db32e7885c081d13e17d795db39556c.svg";
export { ForwardRef as ReactComponent };